<template>
    <div id="content">
        <section class="category-wrap">
            <div class="category-div" v-if="category_list != undefined">
                <span class="cat_1" v-if="category1!=''">{{ getCategoryTitle('category1') }}</span><span class="cat_2" v-if="category2!=''">{{ getCategoryTitle('category2') }}</span>
                <span class="cat_1" v-if="category1=='' && category2==''">全て</span>
            </div>
        </section>
        <section class="content-player-wrap">
            <div v-show="content_type=='video'" class="content-player__area">
                <video id="video01" class="video-js vjs-default-skin vjs-big-play-centered vjs-16-9" data-setup="{}" controls preload="auto" playsinline></video>
            </div>
            <div v-show="content_type=='music'" class="content-player__area">
                <audio class="video-js vjs-default-skin vjs-big-play-centered vjs-16-9" data-setup="{}" controls preload="auto" :poster="'/item/image/'+item_id" id="audio-player" playsinline>
                </audio>
            </div>
            <div class="content-player__data flex">
                <p class="play__title">{{ item_title }}<span class="post-date">{{ content_title }}</span></p>
            </div>
            <div class="content-player__data flex">
                <p class="play__title" v-html="item_description"></p>
            </div>
            <div class="cnt_wrap">
                <div class="fev_addition" v-if="contents.length" :class="{ 'fev_del': contents[playing_number].favorite_status==1 }">
                    <button v-if="contents[playing_number].favorite_status==0" @click="addFavoriteList(playing_number)"><span>お気に入り登録</span></button>
                    <button v-if="contents[playing_number].favorite_status==1" @click="removeFavoriteList(playing_number)"><span>お気に入り削除</span></button>
                </div>
                <div class="fev_addition rep_addition" :class="{ 'rep_del': repeat_flag }">
                    <button @click="changeRepeatFlag"><span>リピート</span></button>
                </div>
                <div class="fev_addition auto_addition" :class="{ 'auto_del': auto_play_flag }">
                    <button @click="changeAutoPlayFlag"><span>自動再生</span></button>
                </div>
            </div>
        </section>

        <section class="content-connection-blc">
            <div class="connection-head flex"><h3><span>関連動画</span></h3></div>
            <div class="acv-list-area flex new-list">
                <article v-for="(random_video, index) in random_video_list" v-show="loaded_list.indexOf(index) !== -1" class="list">
                    <a :href="`/purchased/player/${random_video.digicon_id}?${category_query}`" class="cvr"></a>
                    <p>{{ random_video.title }}</p>
                    <p class="date">{{ random_video.up }}</p>
                    <div class="category-list">
                        <p class="category" v-if="video.category1_name">{{ video.category1_name }}</p>
                        <p class="category" v-if="video.category1_child_name">{{ video.category1_child_name }}</p>
                    </div>
                    <div class="play-btn">
                        <div>
                            <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="#151515" viewBox="0 0 24 24">
                                <path fill-rule="evenodd" d="M8.6 5.2A1 1 0 0 0 7 6v12a1 1 0 0 0 1.6.8l8-6a1 1 0 0 0 0-1.6l-8-6Z" clip-rule="evenodd"/>
                            </svg>
                        </div>
                    </div>
                    <p class="acv-thumb" style="display:none;"><img :src="'/item/image/'+random_video.item_id" alt="" @load="addImageLoadedList(index)"></p>
                </article>
            </div>
        </section>

        <section class="content-connection-blc">
            <div class="connection-head flex"><h3><span>関連音声</span></h3></div>
            <div class="acv-list-area">
                <article v-for="(random_voice, index) in random_voice_list" :key="index" v-show="loaded_list.indexOf(index) !== -1">
                    <a :href="'/purchased/player/'+random_voice.digicon_id+'?category1='+category1+'&category2='+category2" class="cvr"></a>
                    <p class="acv-thumb"><img :src="'/item/image/'+random_voice.item_id" alt="" @load="addImageLoadedList(index)"></p>
                    <p class="date">
                        <span class="play-btn">
                            <img src="/image/tmariko_template/positivesalon/positivesalon/play.svg">
                        </span>
                        <span class="up-v">{{ random_voice.up }}</span>
                        <span class="title-v">{{ random_voice.title }}</span>
                    </p>
                </article>
            </div>
        </section>
    </div><!---end/#content-->
</template>

<script>
    import 'video.js/dist/video-js.css';
    import videojs from 'video.js/dist/video.js';
    export default {
        name: "positivesalon-video-new-player",
        props: {
            first_item_id: {
                type: String,
                default: '0',
            },
            first_digicon_id: {
                type: String,
                default: '0',
            },
            category1: {
                type: String,
                default: '',
            },
            category1_child: {
                type: String,
                default: '',
            },
            category2: {
                type: String,
                default: '',
            },
            category2_child: {
                type: String,
                default: '',
            },
            fav_trans_flag: {
                type: Number,
                default: 0,
            },
            def_auto_play_flag: {
                type: Number,
                default: 0,
            },
            play_type: {
                type: String,
                default: 'video',
            },
        },
        data: function () {
            return {
                item_id: 0,
                digicon_id: 0,
                video: undefined,
                audio: undefined,
                content_title: '',
                item_title: '',
                contents: [],
                playing_number: Number,
                playStartSec: 0,
                repeat_flag: false,
                recordedFlag: false,
                finFlag: false,
                sample_flag: 0,
                loaded_list: [],
                random_video_list: [],
                auto_play_flag: false,
                next_item_id: 0,
                next_digicon_id: 0,
                next_item_id: 0,
                content_type: '',
                category_query: '',
                category_list: undefined,
            }
        },
        created() {
            this.auto_play_flag = this.def_auto_play_flag==1?true:false;
        },
        mounted() {
            console.log(`first_item_id=${this.first_item_id}, first_digicon_id=${this.first_digicon_id}`);
            this.item_id = Number(this.first_item_id);
            this.digicon_id = Number(this.first_digicon_id);
            this.category_query = `category1=${this.category1}&category1_child=${this.category1_child}&category2=${this.category2}&category2_child=${this.category2_child}`;

            this.video = videojs("video01", {html5: {
                }},
            );
            this.audio = videojs("audio-player", {html5: {
                }},
            );
            this.setVideoConfig();
            this.setAudioConfig();
            this.getAlbumInfo();
            this.getRandomVideoList();
            this.getCategoryList();
        },
        methods: {
            play: function() {
                if(this.finFlag) {
                    this.finFlag = false;
                    this.playing_number = 0;
                    this.setDigicon(this.playing_number);
                    return;
                }
                if(this.content_type == 'video') {
                    this.video.play();
                } else {
                    this.audio.play();
                }
                this.resetPlayingSec();
            },
            stop: function() {
                if(this.content_type == 'video') {
                    this.video.pause();
                } else {
                    this.audio.pause();
                }
            },
            setVideoConfig: function() {
                this.video.on('loadedmetadata', function() {
                    this.recordedFlag = false;
                    this.recordContentsPlayLog();
                    this.play();
                }.bind(this));
                this.video.on('timeupdate', function() {
                    this.recordPlayLog();
                }.bind(this));
                this.video.on('ended', function() {
                    this.forward();
                }.bind(this));
            },
            setAudioConfig: function() {
                this.audio.on('loadedmetadata', function() {
                    this.recordedFlag = false;
                    this.recordContentsPlayLog();
                    this.play();
                }.bind(this));
                this.audio.on('timeupdate', function() {
                    this.recordPlayLog();
                }.bind(this));
                this.audio.on('ended', function() {
                    this.forward();
                }.bind(this));
            },
            setDigiconConfig: function(path) {
                console.log(`play digicon_id=${this.digicon_id}, type=${this.content_type}`);
                if(this.content_type == 'video') {
                    this.video.src(path);
                } else {
                    const poster = document.getElementsByClassName("vjs-poster")[1];
                    poster.style.backgroundImage = "url("+`/item/image/${this.item_id}`+")";
                    this.audio.src(path);
                }
            },
            setDigicon: function(playing_number) {
                if(this.contents.length <= playing_number) {
                    this.playing_number = 0;
                    playing_number = this.playing_number;
                }
                this.content_title = this.contents[playing_number].title;
                let digicon_id = this.contents[playing_number].digicon_id;
                this.item_title = this.contents[playing_number].item_title;
                this.item_description = this.contents[playing_number].item_description;
                this.content_type = this.contents[playing_number].type;
                console.log(`content_type=${this.content_type}`);
                axios.default
                    .get('/digicon/content/'+digicon_id)
                    .then(response => {
                        let data = response.data;
                        let playing_path = data.fname;
                        this.setDigiconConfig(playing_path);
                    });
            },
            getAlbumInfo: function() {
                axios.default
                    .post('/purchased/digicon/detail/'+this.item_id, {type: 'content'})
                    .then(response => {
                        let contents = response.data;
                        // for(let i=0; i<contents.length; i++) {
                        //     // this.$set(this.contents, i, contents[i]);
                        // }
                        this.contents = contents;
                        this.jump(this.digicon_id);
                        this.getNextContentInfo();
                });
            },
            getNextContentInfo: function() {
                axios.default
                    .get(`/next_play/digicon_id/get?digicon_id=${this.digicon_id}&${this.category_query}&fav_trans_flag=${this.fav_trans_flag}`)
                    .then(response => {
                        let ret = response.data;
                        this.next_item_id = ret.item_id;
                        this.next_digicon_id = ret.digicon_id;
                });
            },
            forward: function() {
                this.stop();
                if(this.repeat_flag !== true) {
                    if(this.contents.length-1 <= this.playing_number) {
                        this.finFlag = true;
                        if(this.auto_play_flag && this.next_item_id!=0) {
                            console.log(`item_id=${this.item_id}, next_item_id=${this.next_item_id}`);
                            console.log(`digicon_id=${this.digicon_id}, next_digicon_id=${this.next_digicon_id}`);
                            this.item_id = Number(this.next_item_id);
                            this.digicon_id = Number(this.next_digicon_id);
                            this.getAlbumInfo();
                        }
                        return;
                    } else {
                        this.playing_number++;
                    }
                }
                this.setDigicon(this.playing_number);
            },
            jump: function(digicon_id) {
                this.stop();
                let index = 0;
                for(let content of this.contents) {
                    console.log(`jump content.digicon_id=${content.digicon_id}, digicon_id=${digicon_id}`);
                    if(content.digicon_id == digicon_id) {
                        console.log(`jump index=${index}`);
                        this.playing_number = index;
                        this.finFlag = false;
                        this.setDigicon(this.playing_number);
                        break;
                    }
                    index++;
                }
            },
            changeRepeatFlag: function() {
                this.repeat_flag = (this.repeat_flag)?false:true;
            },
            changeAutoPlayFlag: function() {
                this.auto_play_flag = (this.auto_play_flag)?false:true;
            },
            resetPlayingSec: function() {
                this.playStartSec = performance.now();
            },
            recordPlayLog: function() {
                if(!this.checkPlayingSec()) return;
                if(this.recordedFlag) return;
                this.recordedFlag = true;
                let digicon_id = this.contents[this.playing_number].digicon_id;
                axios.default
                    .post('/player/log/add', {digicon_id: digicon_id})
                    .then(response => {
                        if(response.data.status=='error') {
                            this.recordedFlag = false;
                        }
                    });
            },
            recordContentsPlayLog: function() {
                let digicon_id = this.contents[this.playing_number].digicon_id;
                axios.default
                    .get('/playlog/content/add/'+digicon_id, {sample_flag: this.sample_flag})
                    .then(response => {
                        if(!response.data[0].log_id) {
                            console.log('fail record playlog');
                        }
                    });
            },
            checkPlayingSec: function() {
                if(performance.now() - this.playStartSec < 46000) return false;
                return true;
            },
            addFavoriteList: function(index) {
                let digicon_id = this.contents[index]['digicon_id'];
                axios.default
                    .get('/favorite/content/add/'+digicon_id)
                    .then(response => {
                        let res = response.data[0];
                        if(res.error_message) {
                            return;
                        }
                        this.contents[index]['favorite_status'] = 1;
                        this.contents[index]['favorite_id'] = res.favorite_id;
                    });
            },
            removeFavoriteList: function(index) {
                let favorite_id = this.contents[index]['favorite_id'];
                axios.default
                    .get('/favorite/content/remove/'+favorite_id)
                    .then(response => {
                        let res = response.data[0];
                        if(res.error_message) {
                            return;
                        }
                        this.contents[index]['favorite_status'] = 0;
                        this.contents[index]['favorite_id'] = undefined;
                    });
            },
            getRandomVideoList: function() {
                let path = '';
                if(this.play_type=='video') {
                    path = '/movie/get/random';
                } else if(this.play_type=='music') {
                    path = '/voice/get/random';
                }
                axios.default
                    .get(`${path}?item_id=${this.item_id}&${this.category_query}`)
                    .then(response => {
                        this.random_video_list = response.data;
                    });
            },
            addImageLoadedList: function(index) {
                this.loaded_list.push(index);
            },
            getCategoryList: function() {
                axios.default
                    .get(`/item/category/list/get?type=${this.play_type}`)
                    .then(response => {
                        this.category_list = response.data;
                    });
            },
            getCategoryTitle: function(category_type) {
                let category_num;
                let child_num;
                switch(category_type) {
                    case 'category1':
                        category_num = this.category1;
                        child_num = this.category1_child;
                        break;
                    case 'category2':
                        category_num = this.category2;
                        child_num = this.category2_child;
                        break;
                }
                if(category_num=='') {
                    return '全て';
                }
                const category_list = this.category_list[category_type];
                const category = category_list.find(element => element.id == category_num);
                if(category) {
                    const child = category['child'].find(element => element.id == child_num);
                    console.dir(child);
                    if(child) {
                        return child.title;
                    }
                    return category.title;
                }
                return '';
            },
        },
    }
</script>

<style scoped>
</style>
